<template>
  <v-card id="confirm-cancel-modal" class="main-bg" style="background-color: white">
    <v-toolbar class="elevation-0 white" light max-height="64">
      <v-toolbar-title class="black--text"><h3>{{ title }}</h3></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="onCancel()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12" md="6">
            <span style="font-size: 16px;" class="label-text">{{ description }}</span>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field v-model="cancelReason" :rules="rules.cancelReason" label="เหตุผลการปฏิเสธงาน*" filled></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions class="pr-0 pt-10">
          <v-spacer></v-spacer>
          <v-btn class="mr-2 py-2" x-large depressed outlined height="44" color="#D80000" @click="onCancel()">ยกเลิก</v-btn>
          <v-btn class="py-2" dark x-large depressed height="44" color="#D80000" @click="onSubmit()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { ERROR } from '@/store/actions/ui';

export default {
  computed: {
  },
  watch: {},
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  data() {
    return {
      cancelReason: '',
      rules: {
        cancelReason: [
          v => !!v || 'กรุณากรอก เหตุผลการปฏิเสธงาน',
        ],
      }
    };
  },
  async created() {
    // console.log('data', this.data);
    // await this.$store.dispatch(COMMERCIAL_SERVICE_VENDOR_RATING_REQUEST, this.data.objectId);

    // this.selectedChangedStatus = null;

  },
  methods: {
    onCancel() {
      this.$emit('cancelled');
    },
    onSubmit() {
      const payload = this.validate();
      if (payload) {
        this.$emit('saved', payload);
      }
    },
    validate() {
      if (!this.cancelReason) {
        this.$store.dispatch(ERROR, 'กรุณากรอก เหตุผลการปฏิเสธงาน');
        return null;
      }

      return this.cancelReason;
    },
  },
};
</script>
<style lang="scss" scope>
#change-appointment-modal {

}
</style>
